import type { DirectiveBinding, ObjectDirective, VNode } from 'vue';

let appStickyObserver: IntersectionObserver;

/**
 * Добавление sticky
 * К элементу добляется класс переданный как значение диррективы либо **'top-sticky'** по умолчанию
 */
const sticky = {
	mounted(el: HTMLElement, binding: DirectiveBinding, _vnode: VNode) {
		const className = binding.value || 'top-sticky';

		appStickyObserver = new IntersectionObserver(entries => {
			let condition = entries[0].intersectionRatio < 1;
			if (condition) {
				if (binding.modifiers.bottom && entries[0].intersectionRect.y === 0) condition = false;
			}

			el.classList.toggle(className, condition);
		}, {
			threshold: [1],
		});

		appStickyObserver.observe(el);
	},

	unmounted(_el: HTMLElement, _binding: DirectiveBinding, _vnode: VNode) {
		appStickyObserver?.disconnect();
	},
};

export default sticky;
